module.exports = __webpack_public_path__ + "img/trial-widget-bkg.fdd334d0.svg";